import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instance19mvqqhuhhta7 as Companion_instance } from './Optional.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CustomScalarTypeClass;
function CustomScalarType() {
  if (CustomScalarTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, className) {
        super(name);
        this.h47_1 = className;
      }
    }
    initMetadataForClass($, 'CustomScalarType');
    CustomScalarTypeClass = $;
  }
  return CustomScalarTypeClass;
}
var CompiledNamedTypeClass;
function CompiledNamedType() {
  if (CompiledNamedTypeClass === VOID) {
    class $ extends CompiledType() {
      constructor(name) {
        super();
        this.i47_1 = name;
      }
    }
    initMetadataForClass($, 'CompiledNamedType');
    CompiledNamedTypeClass = $;
  }
  return CompiledNamedTypeClass;
}
var CompiledTypeClass;
function CompiledType() {
  if (CompiledTypeClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CompiledType');
    CompiledTypeClass = $;
  }
  return CompiledTypeClass;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(name, type) {
        this.j47_1 = name;
        this.k47_1 = type;
        this.l47_1 = null;
        this.m47_1 = emptyList();
        this.n47_1 = emptyList();
        this.o47_1 = emptyList();
      }
      p47(arguments_0) {
        // Inline function 'kotlin.apply' call
        this.n47_1 = arguments_0;
        return this;
      }
      q47(selections) {
        // Inline function 'kotlin.apply' call
        this.o47_1 = selections;
        return this;
      }
      l38() {
        var tmp0_name = this.j47_1;
        var tmp1_alias = this.l47_1;
        var tmp2_type = this.k47_1;
        var tmp3_condition = this.m47_1;
        var tmp4_arguments = this.n47_1;
        var tmp5_selections = this.o47_1;
        return new (CompiledField())(tmp0_name, tmp2_type, tmp1_alias, tmp3_condition, tmp4_arguments, tmp5_selections);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var CompiledFieldClass;
function CompiledField() {
  if (CompiledFieldClass === VOID) {
    class $ extends CompiledSelection() {
      constructor(name, type, alias, condition, arguments_0, selections) {
        super();
        this.r47_1 = name;
        this.s47_1 = type;
        this.t47_1 = alias;
        this.u47_1 = condition;
        this.v47_1 = arguments_0;
        this.w47_1 = selections;
      }
    }
    initMetadataForClass($, 'CompiledField');
    CompiledFieldClass = $;
  }
  return CompiledFieldClass;
}
var CompiledSelectionClass;
function CompiledSelection() {
  if (CompiledSelectionClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CompiledSelection');
    CompiledSelectionClass = $;
  }
  return CompiledSelectionClass;
}
var BuilderClass_0;
function Builder_0() {
  if (BuilderClass_0 === VOID) {
    class $ {
      constructor(definition) {
        this.x47_1 = definition;
        this.y47_1 = Companion_instance.z47();
      }
      a48(value) {
        // Inline function 'kotlin.apply' call
        this.y47_1 = Companion_instance.b48(value);
        return this;
      }
      l38() {
        return new (CompiledArgument())(this.x47_1, this.y47_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_0 = $;
  }
  return BuilderClass_0;
}
var CompiledArgumentClass;
function CompiledArgument() {
  if (CompiledArgumentClass === VOID) {
    class $ {
      constructor(definition, value) {
        this.c48_1 = definition;
        this.d48_1 = value;
      }
    }
    initMetadataForClass($, 'CompiledArgument');
    CompiledArgumentClass = $;
  }
  return CompiledArgumentClass;
}
var BuilderClass_1;
function Builder_1() {
  if (BuilderClass_1 === VOID) {
    class $ {
      constructor(name) {
        this.e48_1 = name;
        this.f48_1 = false;
      }
      l38() {
        return new (CompiledArgumentDefinition())(this.e48_1, this.f48_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_1 = $;
  }
  return BuilderClass_1;
}
var CompiledArgumentDefinitionClass;
function CompiledArgumentDefinition() {
  if (CompiledArgumentDefinitionClass === VOID) {
    class $ {
      constructor(name, isKey) {
        this.g48_1 = name;
        this.h48_1 = isKey;
        this.i48_1 = false;
      }
    }
    initMetadataForClass($, 'CompiledArgumentDefinition');
    CompiledArgumentDefinitionClass = $;
  }
  return CompiledArgumentDefinitionClass;
}
var CompiledVariableClass;
function CompiledVariable() {
  if (CompiledVariableClass === VOID) {
    class $ {
      constructor(name) {
        this.j48_1 = name;
      }
    }
    initMetadataForClass($, 'CompiledVariable');
    CompiledVariableClass = $;
  }
  return CompiledVariableClass;
}
var BuilderClass_2;
function Builder_2() {
  if (BuilderClass_2 === VOID) {
    class $ {
      constructor(name) {
        this.k48_1 = name;
        this.l48_1 = emptyList();
        this.m48_1 = emptyList();
      }
      l38() {
        return new (ObjectType())(this.k48_1, this.l48_1, this.m48_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_2 = $;
  }
  return BuilderClass_2;
}
var ObjectTypeClass;
function ObjectType() {
  if (ObjectTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, keyFields, implements_0) {
        super(name);
        this.o48_1 = keyFields;
        this.p48_1 = implements_0;
        this.q48_1 = emptyList();
      }
    }
    initMetadataForClass($, 'ObjectType');
    ObjectTypeClass = $;
  }
  return ObjectTypeClass;
}
var CompiledNotNullTypeClass;
function CompiledNotNullType() {
  if (CompiledNotNullTypeClass === VOID) {
    class $ extends CompiledType() {
      constructor(ofType) {
        super();
        this.r48_1 = ofType;
      }
    }
    initMetadataForClass($, 'CompiledNotNullType');
    CompiledNotNullTypeClass = $;
  }
  return CompiledNotNullTypeClass;
}
function notNull(_this__u8e3s4) {
  return new (CompiledNotNullType())(_this__u8e3s4);
}
var CompiledListTypeClass;
function CompiledListType() {
  if (CompiledListTypeClass === VOID) {
    class $ extends CompiledType() {
      constructor(ofType) {
        super();
        this.s48_1 = ofType;
      }
    }
    initMetadataForClass($, 'CompiledListType');
    CompiledListTypeClass = $;
  }
  return CompiledListTypeClass;
}
function list(_this__u8e3s4) {
  return new (CompiledListType())(_this__u8e3s4);
}
var BuilderClass_3;
function Builder_3() {
  if (BuilderClass_3 === VOID) {
    class $ {
      constructor(typeCondition, possibleTypes) {
        this.t48_1 = typeCondition;
        this.u48_1 = possibleTypes;
        this.v48_1 = emptyList();
        this.w48_1 = emptyList();
      }
      q47(selections) {
        // Inline function 'kotlin.apply' call
        this.w48_1 = selections;
        return this;
      }
      l38() {
        return new (CompiledFragment())(this.t48_1, this.u48_1, this.v48_1, this.w48_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_3 = $;
  }
  return BuilderClass_3;
}
var CompiledFragmentClass;
function CompiledFragment() {
  if (CompiledFragmentClass === VOID) {
    class $ extends CompiledSelection() {
      constructor(typeCondition, possibleTypes, condition, selections) {
        super();
        this.x48_1 = typeCondition;
        this.y48_1 = possibleTypes;
        this.z48_1 = condition;
        this.a49_1 = selections;
      }
    }
    initMetadataForClass($, 'CompiledFragment');
    CompiledFragmentClass = $;
  }
  return CompiledFragmentClass;
}
var EnumTypeClass;
function EnumType() {
  if (EnumTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, values) {
        super(name);
        this.c49_1 = values;
      }
    }
    initMetadataForClass($, 'EnumType');
    EnumTypeClass = $;
  }
  return EnumTypeClass;
}
//region block: exports
export {
  Builder_0 as Builder3t31vflw4km89,
  Builder_1 as Builderlyags3ldja2y,
  Builder as Builder320ghmibyd2no,
  Builder_3 as Builder2iaenv1j4gk4w,
  CompiledVariable as CompiledVariablecaz6ndkw7us2,
  CustomScalarType as CustomScalarType8w7iuefxipic,
  EnumType as EnumType11cgb4df0n5r9,
  Builder_2 as Builder3vv3qt9kyowg0,
  list as lista11lrkbcitk,
  notNull as notNull3hndh47e9bowl,
};
//endregion

//# sourceMappingURL=CompiledGraphQL.mjs.map
